











































































































































































































































































































































































































































































































































import Vue from 'vue';
import {
  CalendarEvent,
  CalendarOccurrence,
  Participant,
  Attendee
} from '@/models/calendar';
import { rrulestr, RRule, Weekday, Options } from 'rrule';
import { startsWith, isEqual, clone, isEmpty, find } from 'lodash';
import { FormRules } from '@/mixins/FormRules';
import dateFormat from '@/utils/dateFormat';
import { setPartsToUTCDate, setUTCPartsToDate } from '@/utils/dateHelpers';

import { common_timezones } from '@/components/core/TimeZonePicker/timezones';

import { findExistingIndex, mergeDeep } from '@/utils/helpers';
type AltoleapEvent = CalendarOccurrence | CalendarEvent;
import { mapActions, mapState, mapGetters } from 'vuex';
import { Day } from 'dayspan';
import moment from 'moment-timezone';
import { Contact } from '@/models/contact';
enum RSVP {
  NO,
  YES,
  MAYBE
}
export default Vue.extend({
  mixins: [FormRules],
  data: () => ({
    tab: null,
    open: false,
    emailDialog: false,
    newEntry: true,
    details: {
      recurrence: {
        enabled: false,
        rules: []
      }
    } as any,
    constantDetails: null as any,
    detailOptions: {
      reminder: {
        minutes: 0,
        minutesList: [
          { text: 'minutes', value: 0 },
          { text: 'hours', value: 1 },
          { text: 'days', value: 2 }
        ]
      }
    },
    cacheRules: [] as any[],
    options: {
      freq: RRule.WEEKLY,
      dtstart: new Date(Date.UTC(2020, 3, 24, 5, 0, 0)),
      count: 30,
      interval: 1
    } as Options,
    copy: {
      participants: [] as AltoleapEvent['participants']
    },
    participantsIsLoading: false,
    searchParticipantsQuery: '',
    searchParticipantList: [] as Contact[],
    ruleOptions: {} as Partial<Options>,
    RSVP,
    rsvpChoices: ['No', 'Yes', 'Maybe'],
    recurrenceRule: {
      freq: undefined,
      dtstart: null,
      interval: undefined,
      wkst: null,
      count: null,
      until: null,
      bysetpos: null,
      bymonth: null,
      bymonthday: null,
      bynmonthday: null,
      byyearday: null,
      byweekno: null,
      byweekday: [],
      bynweekday: null,
      byhour: null,
      byminute: null,
      bysecond: null,
      byeaster: null
    } as Partial<Options>
  }),
  computed: {
    ...mapState({
      contacts: (state: any) => state.contacts.contacts,
      calendars: (state: any) => state.calendar.calendars,
      calendarOptions: (state: any) => state.calendar.calendarOptions
    }),
    ...mapGetters({
      getFullName: 'accounts/getFullName',
      getCalendarById: 'calendar/getCalendarById'
    }),

    timezones: () => common_timezones,
    rrulestr: () => rrulestr,

    computedRules(): string[] {
      const ruleList = this.cacheRules.length
        ? this.cacheRules
        : this.details.recurrence?.rules ?? [];
      return ruleList.filter(
        (e: string) => startsWith(e, 'RR') || !startsWith(e, 'DT')
      );
    },
    startEndValidator(): boolean {
      if (this.details.date) {
        return new Day(new Date(this.details.date.end ?? null)).isBefore(
          new Day(new Date(this.details.date.start ?? null)),
          'second'
        );
      } else {
        return false;
      }
    },
    computedDtStart(): Date {
      return this.details.date.start;
    },
    currentRule(): RRule {
      const rule = new RRule({
        ...this.ruleOptions,
        dtstart: this.computedDtStart
      });
      return rule;
    }
  },
  watch: {
    'details.date.start'(date, prevDate) {
      if (this.details.recurrence.enabled) {
        this.updateRule(this.ruleOptions);
      }
      if (!this.details.date.end) {
        this.details.date.end = new Day(new Date(this.details.date.start))
          .add('hour', 1)
          .toDate();
      }
    },
    'details.calendar'(calendar, prevcalendar) {
      if (this.details.recurrence.enabled) {
        this.updateRule(this.ruleOptions);
      }
    },
    searchParticipantsQuery: {
      async handler(participantsQuery, oldClients) {
        // Items have already been loaded
        if (
          this.searchParticipantList.length > 0 &&
          participantsQuery.length < 1
        )
          return;

        // Items have already been requested
        if (this.participantsIsLoading) return;

        this.participantsIsLoading = true;

        // Lazily load input items
        await this.fetchContacts()
          .then(() => {
            this.searchParticipantList = this.contacts;
          })
          .catch((err: any) => console.log(err))
          .finally(() => (this.participantsIsLoading = false));
      }
    },
    open(flag: boolean) {
      flag || this.finishClose();
    }
  },
  methods: {
    dateFormat,
    find,

    ...mapActions('calendar', [
      'fetchCalendars',
      'optionsCalendar',
      'optionsCalendars',
      'fetchCalendarOccurrence',
      'createCalendarEvent',
      'fetchCalendarEvent',
      'updateCalendarEvent',
      'deleteCalendarEvent',
      'updateCalendarOccurrence',
      'deleteCalendarOccurrence',
      'sendCalendarEventInvite',
      'sendCalendarOccurrenceInvite'
    ]),
    ...mapActions('contacts', ['fetchContacts']),
    getRsvpIcon(rsvp: number): string {
      switch (rsvp) {
        case 0:
          return 'mdi-close';
        case 1:
          return 'mdi-check';
        case 2:
          return 'mdi-help';
        default:
          return 'mdi-help';
      }
    },
    getRsvpColor(rsvp: number): string {
      switch (rsvp) {
        case 0:
          return 'red lighten-2';
        case 1:
          return 'success';
        case 2:
          return 'grey';
        default:
          return 'grey';
      }
    },
    updateRule(patterns: Partial<Options>) {
      console.log('Updated recurrence dialog', patterns);

      // this.ruleOptions = patterns;
      this.ruleOptions = mergeDeep(this.recurrenceRule, patterns);

      // using utc to get away from javascripts timezone functionality
      // causes issues uses js timezone

      const rule = RRule.optionsToString({
        ...this.ruleOptions,
        dtstart: this.computedDtStart
      });

      const [DSTART, RULES] = rule.split(/^RRULE:/gim);
      const ruleData = {
        enabled: true,
        rules: [DSTART.toString(), RULES.toString()]
      };
      this.cacheRules = ruleData.rules;
      this.details.recurrence = ruleData;
    },
    setDetails(details: AltoleapEvent, newEntry = true) {
      this.newEntry = newEntry;

      this.details = details ?? this.getDefaultEventDetails();

      if (this.details.calendar !== 0) {
        this.optionsCalendar(this.details.calendar);
      } else {
        this.optionsCalendars();
      }
      this.constantDetails = this.details;
      Object.freeze(this.constantDetails);
      Object.seal(this.constantDetails);
      if (this.details.recurrence.enabled) {
        // const rules = rrulestr(this.details.recurrence.rules.join('\n'));
        const rules = RRule.fromString(
          this.details.recurrence.rules.join('\n')
        );
        this.ruleOptions = rules.origOptions;
        console.log({ RULESTR: rules });
      }
      this.finishOpen();
    },
    edit(event: CalendarOccurrence) {
      this.setDetails(event, false);
    },
    add(event: CalendarEvent) {
      if (event) {
        event.title = '';
      }
      this.setDetails(event);
    },
    openRecurrenece(data: { rule: string | string[]; start: Date }) {
      const recurrenceDialog = (this as any).$refs.recurrenceDialog;
      recurrenceDialog.open({
        rule: data.rule,
        start: data.start ?? this.details.date.start
      });
    },

    finishOpen(ev?: any) {
      if (ev) {
        this.$emit('open', ev);
      }
      this.open = true;
    },
    finishClose(ev?: any) {
      if (ev) {
        this.$emit('close', ev);
      }
      this.newEntry = true;
      this.cacheRules = [];
      this.constantDetails = null;
      this.details = this.getDefaultEventDetails();
      this.$nextTick();
      this.open = false;
    },
    cancel(ev?: any) {
      if (ev) {
        this.$emit('cancel', ev);
      }
      this.checkDetails();
    },

    saved(ev?: any) {
      if (ev) {
        this.$emit('saved', ev);
      }
      this.$emit('saved');
      this.finishClose();
    },
    addSelectedAttendee(attendee: Attendee) {
      const index: number = this.details.participants.findIndex(
        (participant: Participant) => participant.attendee.id === attendee.id
      );
      if (index === -1) {
        this.details.participants?.push({ attendee });
      }
      this.searchParticipantsQuery = '';
    },
    getDefaultEventDetails(): AltoleapEvent | CalendarOccurrence {
      const details = {
        id: null,
        title: '',
        description: '',
        location: '',
        recurrence: {
          enabled: false,
          rules: []
        },
        event: 0,
        calendar: this.calendars[0].id ?? 0,
        owner: this.getFullName || 'Organizer Unknown',
        participants: [],
        reminder: {
          enabled: false,
          minutes: 10
        },
        conference: {
          enabled: false,
          platform: 0
        },
        date: {
          timezone: moment.tz.guess() ?? this.calendars[0].timezone,
          start: setPartsToUTCDate(new Date()),
          end: new Day(setPartsToUTCDate(new Date()))
            .add('hour', 1)
            .startOf('minute')
            .toDate()
        }
      };
      return details;
    },
    inviteParticipants() {
      this.emailDialog = true;
    },
    async openConfirmDialog(
      title?: string,
      buttonOptions?: {
        left?: {
          text: string;
        };
        right?: {
          color?: string;
          text?: string;
          icon?: string;
          iconOnly?: boolean;
        };
      }
    ): Promise<boolean> {
      return await (this as any).$refs.confirmDialog
        .open(title, buttonOptions)
        .then((confirm?: number) => confirm);
    },
    async openChoiceDialog(
      title?: string,
      buttonOptions?: {
        left?: {
          text: string;
        };
        right?: {
          color?: string;
          text?: string;
          icon?: string;
          iconOnly?: boolean;
        };
      }
    ): Promise<boolean> {
      return await (this as any).$refs.choiceDialog
        .open(title, buttonOptions)
        .then((choice?: boolean) => choice);
    },
    async openRecurrenceSave(message = 'Recurrence choice', options?: any) {
      return await (this as any).$refs.recurrenceSaveDialog
        .open(message, options)
        .then((choice?: number) => choice);
    },

    async checkDetails() {
      if (this.newEntry) {
        this.finishClose();
      } else {
        if (!isEqual(this.details, this.constantDetails)) {
          if (
            await this.openConfirmDialog('Discard Changes', {
              right: { text: 'Discard' }
            })
          ) {
            this.finishClose();
          } else {
            return;
          }
        } else {
          this.finishClose();
        }
      }
    },
    // FUNCTION CALLS
    async save(newEntry = false) {
      if (newEntry) {
        this.createEvent();
      } else {
        const choice = await this.openRecurrenceSave(
          this.details.recurrence.enabled
            ? 'Edit Recurring Event'
            : 'Are you sure you want to edit this event?',
          {
            width: this.details.recurrence.enabled ? 300 : 370,
            recurrence: this.details.recurrence.enabled
          }
        );
        switch (choice) {
          case 0:
            return await this.editOccurrence();
          case 1:
          case 2:
            return await this.editEvent();
        }
      }
    },
    async deleteOcc(ev: MouseEvent, title = 'Delete Recurring Event') {
      const choice = await this.openRecurrenceSave(title, {
        recurrence: this.details.recurrence.enabled
      });
      switch (choice) {
        case 0:
          return await this.deleteOccurrence();
        case 1:
        case 2:
          return await this.deleteEvent();
      }
    },
    // API CALLS
    deleteOccurrence() {
      const originalStartDate = new Date(this.constantDetails.original_start);
      (this as any)
        .deleteCalendarOccurrence({
          calendarId: this.constantDetails.calendar,
          eventId: this.constantDetails.event,
          year: originalStartDate.getUTCFullYear(),
          month: originalStartDate.getUTCMonth() + 1,
          day: originalStartDate.getUTCDate(),
          hour: originalStartDate.getUTCHours(),
          minute: originalStartDate.getUTCMinutes(),
          second: originalStartDate.getUTCSeconds(),
          data: this.details
        })
        .then(() => {
          console.log('success deleting');
          this.saved();
        })
        .catch(() => {
          console.log('failed deleting');
        });
    },

    async editOccurrence() {
      const originalStartDate = new Date(this.constantDetails.original_start);

      const event = this.parseEvent(
        Object.assign({}, this.details),
        this.detailOptions
      );
      if (event) {
        (this as any)
          .updateCalendarOccurrence({
            calendarId: this.constantDetails.calendar,
            eventId: this.constantDetails.event,
            year: originalStartDate.getUTCFullYear(),
            month: originalStartDate.getUTCMonth() + 1,
            day: originalStartDate.getUTCDate(),
            hour: originalStartDate.getUTCHours(),
            minute: originalStartDate.getUTCMinutes(),
            second: originalStartDate.getUTCSeconds(),
            data: event
          })
          .then(async (result: CalendarOccurrence) => {
            if (result.participants.length) {
              if (
                await this.openChoiceDialog('Send invite to participants?', {
                  left: { text: 'Dont Send' },
                  right: { text: 'Send', color: 'primary' }
                })
              ) {
                const resultDate = new Date(result.original_start);
                this.sendCalendarOccurrenceInvite({
                  calendarId: result.calendar,
                  eventId: result.event,
                  year: resultDate.getUTCFullYear(),
                  month: resultDate.getUTCMonth() + 1,
                  day: resultDate.getUTCDate(),
                  hour: resultDate.getUTCHours(),
                  minute: resultDate.getUTCMinutes(),
                  second: resultDate.getUTCSeconds()
                }).then(() => {
                  console.log('emails sent');

                  this.saved();
                });
              } else {
                this.saved();
              }
              this.saved();
            }
            this.saved();
          })
          .catch(() => {
            console.log('failed editing');
          });
      } else {
        console.log('No data found in details');
      }
    },
    convertReminderTime(check: boolean, cond: number, time: number): number {
      const DAY = 1440;
      const HOUR = 60;
      if (check) {
        switch (cond) {
          case 0:
            break;
          case 1:
            time = time * HOUR;
            break;
          case 2:
            time = time * DAY; //(60 * 24);
            break;
          default:
            break;
        }
      }
      return time;
    },

    useZoomMeeting(flag = true) {
      if (flag) {
        this.details.conference.enabled = true;
        this.details.conference.platform = 1;
      } else {
        this.details.conference.enabled = false;
        this.details.conference.platform = 0;
      }
    },

    parseEvent(event: AltoleapEvent, options: any): Partial<AltoleapEvent> {
      if (!isEmpty(event)) {
        const parseEventParticipants = (event: AltoleapEvent) => {
          if (event.participants!.length) {
            event.participants =
              event.participants.map((participant: Participant) => {
                return { attendee: participant.attendee.id } || [];
              }) || [];
          }

          return event;
        };
        event.reminder!.minutes = this.convertReminderTime(
          event.reminder!.enabled,
          options.reminder.minutes,
          event.reminder!.minutes
        );

        event = parseEventParticipants(event);

        return event;
      } else return event;
    },

    async createEvent() {
      const event = this.parseEvent(
        Object.assign({}, this.details),
        this.detailOptions
      );
      if (event) {
        (this as any)
          .createCalendarEvent({
            calendarId: event.calendar,
            data: event
          })
          .then(async (result: CalendarEvent) => {
            console.log('success creating calendar occurrence');
            if (result.participants.length) {
              if (
                await this.openChoiceDialog('Send invite to participants?', {
                  left: { text: 'Dont Send' },
                  right: { text: 'Send', color: 'primary' }
                })
              ) {
                console.log('send emails');
                this.sendCalendarEventInvite({
                  calendarId: result.calendar,
                  eventId: result.id
                }).then(() => {
                  this.saved();
                });
              } else {
                this.saved();
              }
            }
            this.saved();
          })
          .catch(() => {
            console.log('failed creating');
          });
      } else {
        console.log('No data found in details');
      }
    },
    async deleteEvent() {
      const event = this.parseEvent(
        Object.assign({}, this.details),
        this.detailOptions
      );
      if (event) {
        (this as any)
          .deleteCalendarEvent({
            calendarId: this.constantDetails.calendar,
            eventId: this.constantDetails.event
          })
          .then(() => {
            console.log('success deleteing calendar event');
            this.saved();
          })
          .catch(() => {
            console.log('failed deleting calendar event');
          });
      } else {
        console.log('No data found in details');
      }
    },
    async editEvent() {
      const event = this.parseEvent(
        Object.assign({}, this.details),
        this.detailOptions
      );
      if (event) {
        (this as any)
          .updateCalendarEvent({
            calendarId: this.constantDetails.calendar,
            eventId: this.constantDetails.event,
            data: event
          })
          .then(async (result: CalendarEvent) => {
            console.log('success editing calendar occurrence');
            if (result.participants.length) {
              if (
                await this.openChoiceDialog('Send invite to participants?', {
                  left: { text: 'Dont Send' },
                  right: { text: 'Send', color: 'primary' }
                })
              ) {
                console.log('send emails');
                this.sendCalendarEventInvite({
                  calendarId: result.calendar,
                  eventId: result.id
                }).then(() => {
                  this.saved();
                });
              } else {
                this.saved();
              }
            }
            this.saved();
          })
          .catch(() => {
            console.log('failed editing');
          });
      } else {
        console.log('No data found in details');
      }
    },
    getParticipantName(item: any): string {
      return item.name.first + ' ' + item.name.last;
    },
    getAttendeeInitials(contact: Contact) {
      return (
        contact.name.first.substring(0, 1).toUpperCase() +
        contact.name.last.substring(0, 1).toUpperCase()
      );
    }
  },
  mounted() {
    this.details = this.getDefaultEventDetails();
  }
});
